export const CampaignType = {
  DIRECT: 1,
  PERCENT: 2,
  XY: 3,
  GIFT: 4
};

export const CampaignTypes = [
  {
    type: CampaignType.DIRECT,
    name: 'Giảm giá trực tiếp',
    icon: 'mdi-ticket-percent',
    color: '#279600',
    background: '#DAECD9'
  },
  {
    type: CampaignType.PERCENT,
    name: 'Giảm giá theo %',
    icon: 'mdi-percent-box',
    color: '#279600',
    background: '#DAECD9'
  },
  {
    type: CampaignType.XY,
    name: 'Mua X tặng Y',
    icon: 'mdi-package-variant-closed-plus',
    color: '#009FE0',
    background: '#D9F1FA'
  },
  {
    type: CampaignType.GIFT,
    name: 'Quà tặng',
    icon: 'mdi-gift',
    color: '#FF0000',
    background: '#FFD9D9'
  }
];

export function getCampaignType(type) {
  return CampaignTypes.find(it => it.type == type);
}

export function getDiscount(prod) {
  const campaignApplies = prod.campaigns || []; // trường campaigns được gửi trong request
  let finalIntoMoney = prod.count * Number(prod.price);
  for (const campaignApply of campaignApplies) {
    // const campaign = campaignsObject[campaignApply.code]; // data campaign
    if (campaignApply.type === CampaignType.DIRECT) {
      // giảm giá trực tiếp
      const discountAmount =
        Number(campaignApply.raw.promotionDiscount) * prod.count;
      finalIntoMoney -= discountAmount < finalIntoMoney ? discountAmount : finalIntoMoney;
    } else if (campaignApply.type === CampaignType.PERCENT) {
      // giảm giá theo %
      const discountPercentage = Math.min(campaignApply.raw.promotionDiscount, 100);
      // OMS-1771: Áp dụng khuyến mại theo thứ tự => Km theo % cần tính theo số tiền sau khi áp các km trước
      let discountAmount = Math.floor(
        (finalIntoMoney * discountPercentage) / 100
      );
      if (!_.isNil(campaignApply.raw.numberOfAvailableOrder)) {
        // Nếu có số tiền giảm tối đa
        // Nếu campaign có số tiền giảm tối đa
        discountAmount = Math.min(
          discountAmount,
          campaignApply.raw.numberOfAvailableOrder
        );
      }
      finalIntoMoney -= discountAmount < finalIntoMoney ? discountAmount : finalIntoMoney;
    }
  }
  // if (count > prod.price) count = prod.price;
  return (prod.count * Number(prod.price)) - finalIntoMoney;
}
